import { css } from 'styled-components';

export const pretendardFont = css`
  font-family: ${({ theme }) => theme.typography.fontFamily};
`;
